"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationButton = function PaginationButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      selected = _ref.selected,
      disabled = _ref.disabled,
      ariaLabel = _ref.ariaLabel;
  var style = (0, _classnames.default)({
    'co--active': selected,
    'co--disabled': disabled
  });

  var clickHandler = function clickHandler(e) {
    e.preventDefault();

    if (!disabled) {
      onClick();
    }
  };

  return _react.default.createElement("li", {
    className: style,
    onClick: clickHandler
  }, _react.default.createElement("a", {
    href: "#",
    "aria-label": ariaLabel
  }, children));
};

PaginationButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string
};
var _default = PaginationButton;
exports.default = _default;
PaginationButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PaginationButton",
  "props": {
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "selected": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "ariaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};